import type { WindowLevels, WindowLevel } from '@/modules/Editor/imageManipulation'
import type { View } from '@/modules/Editor/views/view'

const windowLevelRangeToWindowLevel = (windowLevelRange: WindowLevels): WindowLevel => {
  const [min, max] = windowLevelRange
  const width = max - min
  const level = min + width / 2
  return {
    width: Math.round(width),
    level: Math.round(level),
  }
}

const getWindowLevel = (view: View): WindowLevel => {
  const { imageFilter } = view
  // Note what we call "WindowLevels" throughout the app is incorrect,
  // but this is a larger task to tackle.
  const { windowLevels: windowLevelRange } = imageFilter
  return windowLevelRangeToWindowLevel(windowLevelRange)
}

const setWindowLevel = (view: View, windowLevel: WindowLevel): void => {
  const { imageFilter } = view

  const { level, width } = windowLevel
  const halfWindow = width / 2

  const newWindowLevelRange: WindowLevels = [level - halfWindow, level + halfWindow]

  imageFilter.windowLevels = newWindowLevelRange
  view.setImageFilter(imageFilter)
}

const windowLevelController = (windowLevelRange: WindowLevels): WindowLevel =>
  windowLevelRangeToWindowLevel(windowLevelRange)

const setWindowLevelController = (
  level: number,
  window: number,
  setWindowLevel: (windowLevels: WindowLevels) => void,
): void => {
  const halfWindow = window / 2

  const newWindowLevelRange: WindowLevels = [level - halfWindow, level + halfWindow]

  setWindowLevel(newWindowLevelRange)
}

export { getWindowLevel, setWindowLevel, windowLevelController, setWindowLevelController }
